import UCWordmark from "../common/uCWordmark";

import './style.scss';
import AriaLiveRegion from "../common/ariaLiveRegion";

const Footer = () => {
  return (
    <footer className="primary-footer">
      <UCWordmark />
      <div className="copyright-links">
        <p>Copyright &#169; Regents of the University of California</p>
        <span className="fpipe1">|</span> <a href="https://www.ucop.edu/terms/index.html">Terms of use</a> <span className="fpipe2"></span>
      </div>
      <AriaLiveRegion />
    </footer>
  );
}

export default Footer;